define(["./nodeCommandsModule"], function (nodeCommandsModule) {
    "use strict";

    return nodeCommandsModule.service("nodeCommandPermissionGroupPurge", [
        "messagesModal",
        "$http",
        "loadingService",
        "remoteExceptionHandler",
        "pathService",
        function (messagesModal, $http, loadingService, remoteExceptionHandler, pathService) {
            return function (selection, context) {
                if (selection && selection.length > 0) {
                    return messagesModal.cancellable("dialog.proceed?", "permissionGroupPurge.modal.body")
                        .then(function () {
                            return loadingService($http.post(pathService.getPath("purge"), selection[0].id))
                                .catch(remoteExceptionHandler());
                        }).then(function () {
                            return messagesModal("dialog.success", "permissionGroupPurge.modal.success").then(function () {
                                return context.refilter();
                            });
                        });
                }
            };
        }
    ]);
});